<div class="container">
  <div class="row">
    <div class="col-12 text-center">
      <img class="" src="/assets/e404.png" alt="404">
    </div>
    <div class="col-12 text-center">
        <p>
          <b class="text-danger">You have been directed to a page that does not exists. Please use the menu to take you to another page.</b>
        </p>
    </div>
  </div>
  
</div>
